function MerchantNoRebateLabel({ label = '' }) {
  return label || 'See More';
}

export default MerchantNoRebateLabel;
